export const core_company_index = ['corecompanies.index']
export const core_company_create = ['corecompanies.create']
export const core_careunit_index = ['corecareunits.index']
export const core_careunit_create = ['corecareunits.create']
export const core_sector_index = ['coresectors.index']
export const core_sector_create = ['coresectors.create']

export default [].concat(
    core_company_index,
    core_company_create,
    core_careunit_index,
    core_careunit_create,
    core_sector_index,
    core_sector_create
)